import React, { useEffect } from 'react';
import OLSnapInteraction from 'ol/interaction/Snap';
import Collection from 'ol/Collection';
import { geoJSONToFeature } from '../../utils/geoJSONFeature';
import { useOLMap } from '../MapContext';
import { featureToGeoJSONObject } from '../../utils/featureToGeoJSONObject';
import { actionSetSnapInteraction } from '../../actions';
export const InteractionSnap = React.memo(({ dispatch, features, layerFeatureIds, layerIds, pixelTolerance, ...options }) => {
    const map = useOLMap();
    useEffect(() => {
        const olMap = map;
        const layerFilter = (layer) => {
            return layerIds.includes(layer.get('id'));
        };
        const handlePointerMove = (event) => {
            requestAnimationFrame(() => {
                const snapFeatures = [];
                const newLayerFeatureIds = [];
                olMap.forEachFeatureAtPixel(event.pixel, (feature, layer) => {
                    const layerId = layer?.get('id');
                    const featureId = feature.getId() ?? feature.get('id');
                    if (layerId && featureId) {
                        snapFeatures.push(featureToGeoJSONObject(feature));
                        newLayerFeatureIds.push({ layerId, featureId });
                    }
                }, {
                    layerFilter,
                    hitTolerance: pixelTolerance,
                });
                if (snapFeatures.length) {
                    if (layerFeatureIds.length !== newLayerFeatureIds.length ||
                        layerFeatureIds.some((layerFeatureId, idx) => newLayerFeatureIds[idx].featureId !== layerFeatureId.featureId ||
                            newLayerFeatureIds[idx].layerId !== layerFeatureId.layerId)) {
                        dispatch(actionSetSnapInteraction({
                            features: snapFeatures,
                            layerFeatureIds: newLayerFeatureIds,
                        }));
                    }
                }
            });
        };
        olMap.on('pointermove', handlePointerMove);
        return () => {
            if (olMap) {
                olMap.un('pointermove', handlePointerMove);
            }
        };
    }, [map, dispatch, layerIds, pixelTolerance, features, layerFeatureIds]);
    useEffect(() => {
        if (!features.length)
            return;
        let featuresCollection;
        if (features) {
            featuresCollection = new Collection(features.map((geoJsonFeature) => geoJSONToFeature(geoJsonFeature).clone()));
        }
        const interaction = new OLSnapInteraction({
            ...options,
            pixelTolerance,
            features: featuresCollection,
        });
        if (process.env.NODE_ENV === 'development') {
            console.log('new OLSnapInteraction', interaction);
        }
        const interactions = map.getInteractions();
        interactions.push(interaction);
        // // Dobre pro vyvoj, vykresli snap zlute podbarveni
        // const source = new VectorSource({
        //   features: featuresCollection,
        // });
        // const snapLayer = new VectorLayer({
        //   source,
        //   style: new Style({
        //     stroke: new Stroke({
        //       color: '#ffff00',
        //       width: pixelTolerance,
        //     }),
        //   }),
        //   visible: true,
        //   zIndex: -1,
        // });
        // map.addLayer(snapLayer);
        return () => {
            interactions.remove(interaction);
            // map.removeLayer(snapLayer);
        };
    }, [map, options, features, pixelTolerance]);
    return null;
});
//# sourceMappingURL=InteractionSnap.js.map